import {
    type Environments,
    type Paddle,
    initializePaddle,
} from "@paddle/paddle-js";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { env } from "@/env";
import { orpc } from "@/orpc/react-query";

export function usePaddle() {
    const [paddle, setPaddle] = useState<Paddle | undefined>(undefined);

    const { data: user } = useQuery(orpc.user.getMe.queryOptions());

    useEffect(() => {
        if (env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN && env.NEXT_PUBLIC_PADDLE_ENV) {
            initializePaddle({
                token: env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN,
                environment: env.NEXT_PUBLIC_PADDLE_ENV as Environments,
                pwCustomer: {
                    email: user?.email,
                },
            }).then((paddle) => {
                if (paddle) {
                    setPaddle(paddle);
                }
            });
        }
    }, [user?.email]);

    return {
        paddle,
    };
}
